<template>
  <div class="container-fluid d-flex flex-wrap pt-3 main-wrapper" style="background: #2B0000; 
        height: 80vh; 
        min-height: 100vh;
        background-size: cover; 
        background-attachment: fixed; 
        overflow-y: scroll; ">
      <div class="col-lg-12 col-12 p-0 pb-5">
          <div>
              <div class="bg-transparent pl-4 pt-3">
                  <div class="row align-items-center">
                      <div class="col-8">
                          <h3 class="mb-0 text-white">
                              {{ $t('withdraw.withdraw_form') }}
                          </h3>
                      </div>
                  </div>
                  <van-radio-group
                      v-if="showModeSelector"
                      v-model="withdrawMode"
                      class="d-flex justify-content-center mb-2 mt-2"
                      @change="onWithdrawModeChange"
                  >
                      <van-radio
                          class="mx-3 my-1"
                          style="color: white !important;"
                          name="auto"
                          checked-color="#ee0a24"
                      >{{ $t('withdraw.auto_payment') }}</van-radio>
                      <van-radio
                          class="mx-3 my-1"
                          style="color: white !important;"
                          name="manual"
                          checked-color="#ee0a24"
                      >{{ $t('withdraw.manual_payment') }}</van-radio>
                  </van-radio-group>
              </div>

              <div
                  v-if="pspWithdraw"
                  class="col-12 p-0 d-flex flex-wrap px-4"
              >
                  <div class="col-lg-6 col-12 py-2 pb-4 psp-withdraw-panel">
                      <p
                          v-if="pspResumed"
                          class="text-warning mb-2"
                      >{{ $t('withdraw.resumed_withdraw') }}</p>
                      <h3 style="color: #FFE93C !important; font-weight: 600;">
                          {{ pspWithdraw.bank_name }}
                      </h3>
                      <div class="number-container d-flex py-3 my-2 text-white">
                          {{ $t('withdraw.amount') }}:&nbsp;
                          <h3 class="m-0" style="color: #FFE93C !important; font-weight: 600;">
                              {{ Number(pspWithdraw.amount).toLocaleString() }} MMK
                          </h3>
                      </div>
                      <div
                          v-if="pspWithdraw.transaction_code"
                          class="number-container d-flex flex-wrap py-3 my-2 text-white align-items-center"
                      >
                          {{ $t('withdraw.transaction_code') }}:&nbsp;
                          <h3 class="m-0 mr-2" style="color: #FFE93C !important; font-weight: 600; word-break: break-all;">
                              {{ pspWithdraw.transaction_code }}
                          </h3>
                          <span
                              class="text-danger badge badge-danger"
                              @click="copyText(pspWithdraw.transaction_code)"
                          >Copy</span>
                      </div>
                      <div
                          v-if="pspWithdraw.transaction_no"
                          class="number-container d-flex py-3 my-2 text-white"
                      >
                          {{ $t('withdraw.transaction_no') }}:&nbsp;
                          <h3 class="m-0" style="color: #FFE93C !important; font-weight: 600;">
                              {{ pspWithdraw.transaction_no }}
                          </h3>
                      </div>
                      <div class="number-container d-flex py-3 my-2 text-white">
                          {{ $t('withdraw.account_number') }}:&nbsp;
                          <h3 class="m-0" style="color: #FFE93C !important; font-weight: 600;">
                              {{ pspWithdraw.account_number }}
                          </h3>
                      </div>
                      <div class="number-container d-flex py-3 my-2 text-white">
                          {{ $t('deposit.account_name') }}:&nbsp;
                          <h3 class="m-0" style="color: #FFE93C !important; font-weight: 600;">
                              {{ pspWithdraw.account_name }}
                          </h3>
                      </div>
                      <template v-if="showMyanpayOtpForm">
                          <p class="text-white mb-2">{{ $t('withdraw.otp_required') }}</p>
                          <div class="form-group mt-2">
                              <label class="form-control-label text-white">{{ $t('withdraw.enter_otp') }}</label>
                              <input
                                  type="tel"
                                  inputmode="numeric"
                                  class="form-control"
                                  v-model="myanpayOtp"
                                  maxlength="10"
                                  style="border-radius: 8px; border: none; background-color: rgba(255,255,255,0.2) !important; color: #FFE93C !important; font-weight: 600; box-shadow: none;"
                              />
                          </div>
                          <div class="d-flex flex-wrap mt-2">
                              <button
                                  type="button"
                                  class="btn btn-warning mr-2 mb-2"
                                  :disabled="isSubmittingOtp"
                                  @click="submitMyanpayOtp"
                              >
                                  {{ isSubmittingOtp ? $t('deposit.verifying') : $t('withdraw.submit_otp') }}
                              </button>
                              <button
                                  type="button"
                                  class="btn btn-sm btn-outline-light mb-2"
                                  @click="resendMyanpayOtp"
                              >{{ $t('withdraw.resend_otp') }}</button>
                          </div>
                      </template>
                      <template v-else>
                          <p class="text-white mb-2">{{ $t('withdraw.processing_hint') }}</p>
                          <p class="text-white text-sm mt-2">{{ $t('withdraw.waiting_confirm') }}</p>
                          <p
                              v-if="isCheckingStatus"
                              class="text-info text-sm mt-2 mb-0"
                          >{{ $t('withdraw.checking_status') }}</p>
                      </template>
                  </div>
              </div>

              <div
                  v-if="!pspWithdraw"
                  class="card-body"
              >
                  <form>
                      <div class="pl-lg-4">
                          <div class="row">
                              <div class="col-lg-6">
                                  <div class="form-group">
                                      <label
                                          class="form-control-label text-white"
                                          for="input-username"
                                      >{{ $t('withdraw.choose_payment_type') }}</label>
                                      <AccountSelect
                                          :data="selected_account"
                                          field="account_id"
                                          :accounts="activeAccounts"
                                          variant="withdraw"
                                      />
                                      <span class="text-danger">{{
                                          errors.account
                                      }}</span>
                                  </div>
                              </div>
                          </div>
                      </div>

                      <div class="pl-lg-4">
                          <div class="row">
                              <div class="col-lg-6">
                                  <div class="form-group">
                                      <label
                                          class="form-control-label text-white"
                                          for="input-email"
                                      >{{ $t('withdraw.account_number') }}</label>
                                      <input
                                          type="tel"
                                          inputmode="tel"
                                          autocomplete="tel"
                                          class="form-control"
                                          :class="{ 'phone-input--invalid': errors.number }"
                                          style="border-radius: 8px; border: none; background-color: rgba(255,255,255,0.2) !important; color: #FFE93C !important; font-weight: 600; box-shadow: none;"
                                          placeholder="09xxxxxxxxx"
                                          maxlength="20"
                                          v-model="withdrawData.account_number"
                                          @blur="validateAccountNumber(true)"
                                          @input="onAccountNumberInput"
                                      />
                                      <span class="text-danger">{{
                                          errors.number
                                      }}</span>
                                  </div>
                              </div>

                              <div class="col-lg-6">
                                  <div class="form-group">
                                      <label
                                          class="form-control-label text-white"
                                          for="input-email"
                                      >{{ $t('deposit.account_name') }}</label>
                                      <input
                                          class="form-control"
                                          style="border-radius: 8px; border: none; background-color: rgba(255,255,255,0.2) !important; color: #FFE93C !important; font-weight: 600; box-shadow: none;"
                                          placeholder="Account Name"
                                          v-model="withdrawData.account_name"
                                      />
                                      <span class="text-danger">{{
                                          errors.name
                                      }}</span>
                                  </div>
                              </div>

                              <div class="col-lg-6">
                                  <div class="form-group">
                                      <label class="form-control-label text-white">{{ $t('withdraw.amount') }}</label>
                                      <span class="text-danger text-xs" style="color: #EFDB01 !important">
                                        {{ $t('withdraw.minimum_deposit') }}{{ $t('withdraw.maximum_withdraw') }}
                                      </span>
                                      <input
                                          type="number"
                                          id="input-email"
                                          class="form-control"
                                          style="border-radius: 8px; border: none; background-color: rgba(255,255,255,0.2) !important; color: #FFE93C !important; font-weight: 600; box-shadow: none;"
                                          placeholder="Amount"
                                          v-model="withdrawData.amount"
                                      />
                                      <span class="text-danger">{{
                                          errors.amount
                                      }}</span>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div class="pl-lg-4">
                          <div class="form-group">
                              <label class="form-control-label text-white">{{ $t('withdraw.remark') }}</label>
                              <textarea
                                  rows="4"
                                  class="form-control"
                                  v-model="withdrawData.remark"
                                  style="border-radius: 8px; border: none; background-color: rgba(255,255,255,0.2) !important; color: #FFE93C !important; font-weight: 600; font-size: 14px; box-shadow: none;"
                                  placeholder="Remark"
                              ></textarea>
                          </div>
                          <div class="form-group">
                              <button
                                  type="button"
                                  class="btn btn-success text-dark custom-btn"
                                  @click="sendWithdrawData"
                              >
                                  <div v-if="!isConfirm">
                                      {{ $t('withdraw.submit') }}
                                  </div>
                                  <Loading
                                      color="#ffffff"
                                      v-if="isConfirm"
                                      size="24"
                                      class="px-4 py-0"
                                  />
                              </button>
                          </div>
                      </div>
                  </form>
              </div>
          </div>
      </div>
  </div>
</template>
<script>
import { Toast, Dialog, Loading } from 'vant';
import { mapActions } from 'vuex';
import AccountSelect from './components/AccountSelect.vue';
import {
  defaultWithdrawMode,
  applyAutoWithdrawResponse,
  applyPendingWithdrawFromConfig,
  resolveAutoWithdrawAccounts,
  MANUAL_WITHDRAW_ACCOUNTS,
} from '../../utils/paymentBanks';

const MAX_WITHDRAW_AMOUNT = 1000000;

export default {
  components: { AccountSelect, Loading },
  data() {
    return {
      imageUploader: [],
      selected_account: {
        account_id: null,
      },
      pspBanks: [],
      paymentSettings: {},
      withdrawMode: 'manual',
      pspWithdraw: null,
      pspWithdrawId: null,
      pspResumed: false,
      autoWithdrawProvider: 'mcpay',
      myanpayOtp: '',
      isSubmittingOtp: false,
      isCheckingStatus: false,
      statusPollTimer: null,
      account: [],
      withdrawData: {},
      errors: {},
      isConfirm: false,
      isReviewing: false,
      accountNumberTouched: false,
    };
  },
  methods: {
    ...mapActions(['fetchUser']),
    onWithdrawModeChange() {
      this.selected_account.account_id = null;
      this.errors = {};
      this.accountNumberTouched = false;
    },
    onAccountNumberInput() {
      if (this.accountNumberTouched) {
        this.validateAccountNumber();
      }
    },
    isValidMyanmarPhone(value) {
      const phone = String(value || '').trim();
      if (!phone) {
        return false;
      }

      try {
        const myanmarPhoneNumber = require('myanmar-phonenumber');
        return myanmarPhoneNumber.isValidMMPhoneNumber(phone);
      } catch (error) {
        return false;
      }
    },
    normalizeMyanmarPhone(value) {
      const phone = String(value || '').trim();
      try {
        const myanmarPhoneNumber = require('myanmar-phonenumber');
        return myanmarPhoneNumber.normalizeInput(phone);
      } catch (error) {
        return phone;
      }
    },
    validateAccountNumber(normalize) {
      this.accountNumberTouched = true;
      const phone = String(this.withdrawData.account_number || '').trim();

      if (!phone) {
        this.$set(
          this.errors,
          'number',
          this.$t('withdraw.enter_account_number'),
        );
        return false;
      }

      if (!this.isValidMyanmarPhone(phone)) {
        this.$set(this.errors, 'number', this.$t('withdraw.invalid_phone'));
        return false;
      }

      if (normalize) {
        const normalized = this.normalizeMyanmarPhone(phone);
        if (normalized && normalized !== this.withdrawData.account_number) {
          this.$set(this.withdrawData, 'account_number', normalized);
        }
      }

      this.$delete(this.errors, 'number');
      return true;
    },
    escapeDialogText(value) {
      return String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    },
    async confirmWithdrawDetails() {
      const type = this.escapeDialogText(this.selectedAccountLabel);
      const name = this.escapeDialogText(this.withdrawData.account_name);
      const number = this.escapeDialogText(String(this.withdrawData.account_number || '').trim());
      const message = `
        <div class="withdraw-confirm">
          <p class="withdraw-confirm__hint">${this.escapeDialogText(this.$t('withdraw.confirm_check_again'))}</p>
          <div class="withdraw-confirm__row">
            <span class="withdraw-confirm__label">${this.escapeDialogText(this.$t('withdraw.choose_payment_type'))}</span>
            <span class="withdraw-confirm__value">${type}</span>
          </div>
          <div class="withdraw-confirm__row">
            <span class="withdraw-confirm__label">${this.escapeDialogText(this.$t('deposit.account_name'))}</span>
            <span class="withdraw-confirm__value">${name}</span>
          </div>
          <div class="withdraw-confirm__row">
            <span class="withdraw-confirm__label">${this.escapeDialogText(this.$t('withdraw.account_number'))}</span>
          </div>
          <div class="withdraw-confirm__phone">${number}</div>
          <p class="withdraw-confirm__alert">မိမိရိုက်ထည့်ထားသောဖုန်းနံပါတ်မှားယွင်းနေပါက မိမိတာဝန်သာဖြစ်သည် company မှ တာဝန်ယူမည်မဟုတ်ပါ၊</p>
        </div>
      `;

      try {
        await Dialog.confirm({
          title: this.$t('withdraw.confirm_title'),
          message,
          allowHtml: true,
          className: 'withdraw-confirm-dialog',
          confirmButtonText: this.$t('withdraw.confirm_submit'),
          cancelButtonText: this.$t('withdraw.go_back'),
          confirmButtonColor: '#ee0a24',
        });
        return true;
      } catch (error) {
        return false;
      }
    },
    copyText(text) {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      Toast.success(
        this.$store.state.language === 'en'
          ? 'Copied'
          : 'ကူးယူပြီးပါပြီ',
      );
    },
    applyPspWithdraw(result) {
      if (!result) {
        return;
      }

      this.pspWithdraw = result.summary;
      this.pspWithdrawId = result.withdrawId;
      this.pspResumed = result.resumed;
      this.autoWithdrawProvider = result.provider || result.summary?.provider || 'mcpay';
      this.myanpayOtp = '';

      if (result.summary?.otp_required || result.gatewayResponse?.status === 'otp_required') {
        this.stopStatusPolling();
        this.isCheckingStatus = false;
        return;
      }

      if (this.autoWithdrawProvider === 'myanpay' && result.summary?.status === 'confirm') {
        this.stopStatusPolling();
        this.isCheckingStatus = false;
        this.clearPspWithdraw();
        this.fetchUser();
        Toast.success(this.$t('withdraw.withdraw_confirmed'));
        return;
      }

      this.startStatusPolling();
    },
    clearPspWithdraw() {
      this.stopStatusPolling();
      this.pspWithdraw = null;
      this.pspWithdrawId = null;
      this.pspResumed = false;
      this.autoWithdrawProvider = 'mcpay';
      this.myanpayOtp = '';
      this.isSubmittingOtp = false;
      this.isCheckingStatus = false;
    },
    startStatusPolling() {
      this.stopStatusPolling();
      if (!this.pspWithdrawId) {
        return;
      }

      this.isCheckingStatus = true;
      this.checkPspWithdrawStatus();
      this.statusPollTimer = setInterval(() => {
        this.checkPspWithdrawStatus();
      }, 15000);
    },
    stopStatusPolling() {
      if (this.statusPollTimer) {
        clearInterval(this.statusPollTimer);
        this.statusPollTimer = null;
      }
    },
    async submitMyanpayOtp() {
      if (!this.pspWithdrawId || !this.myanpayOtp) {
        Dialog.alert({
          message: this.$t('withdraw.enter_otp'),
          confirmButtonText: this.$t('withdraw.go_back'),
        });
        return;
      }

      this.isSubmittingOtp = true;
      try {
        await axios.post(`/myanpay/withdraws/${this.pspWithdrawId}/otp`, {
          otp: this.myanpayOtp,
        }, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });

        this.clearPspWithdraw();
        await this.fetchUser();
        Toast.success(this.$t('withdraw.withdraw_confirmed'));
      } catch (error) {
        const errorMessage = error.response?.data?.message || this.$t('withdraw.withdraw_failed');
        Dialog.alert({
          message: errorMessage,
          confirmButtonText: this.$t('withdraw.go_back'),
        });
        await this.fetchUser();
        this.clearPspWithdraw();
      } finally {
        this.isSubmittingOtp = false;
      }
    },
    async resendMyanpayOtp() {
      if (!this.pspWithdrawId) {
        return;
      }

      try {
        await axios.post(`/myanpay/withdraws/${this.pspWithdrawId}/otp/resend`, {}, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });
        Toast.success(this.$t('withdraw.resend_otp'));
      } catch (error) {
        Dialog.alert({
          message: error.response?.data?.message || this.$t('withdraw.withdraw_failed'),
          confirmButtonText: this.$t('withdraw.go_back'),
        });
      }
    },
    async checkPspWithdrawStatus() {
      if (!this.pspWithdrawId || this.autoWithdrawProvider === 'myanpay') {
        return;
      }

      try {
        const res = await axios.get(`/psp/withdraws/${this.pspWithdrawId}/status`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });

        const withdraw = res.data?.data?.withdraw;
        if (withdraw?.status === 'confirm') {
          this.stopStatusPolling();
          this.isCheckingStatus = false;
          this.clearPspWithdraw();
          await this.fetchUser();
          Toast.success(this.$t('withdraw.withdraw_confirmed'));
        } else if (withdraw?.status === 'fail') {
          this.stopStatusPolling();
          this.isCheckingStatus = false;
          this.clearPspWithdraw();
          await this.fetchUser();
          Dialog.alert({
            message: this.$t('withdraw.withdraw_failed'),
            confirmButtonText: this.$t('withdraw.go_back'),
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    async loadPaymentConfig() {
      try {
        const res = await axios.get('/auto-payment/config', {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });
        this.paymentSettings = res.data.payment_settings || {};
        this.pspBanks = resolveAutoWithdrawAccounts(res.data);
        this.withdrawMode = defaultWithdrawMode(this.paymentSettings);

        const pending = applyPendingWithdrawFromConfig(res.data.pending_withdraw);
        if (pending) {
          this.applyPspWithdraw(pending);
        }
      } catch (error) {
        try {
          const res = await axios.get('/psp/banks', {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
          });
          this.paymentSettings = res.data.payment_settings || {};
          this.pspBanks = resolveAutoWithdrawAccounts({
            payment_settings: res.data.payment_settings,
            providers: {
              mcpay: {
                configured: res.data.configured,
                banks: res.data.banks || [],
              },
            },
          });
          this.withdrawMode = defaultWithdrawMode(this.paymentSettings);

          const pending = applyPendingWithdrawFromConfig(res.data.pending_withdraw);
          if (pending) {
            this.applyPspWithdraw(pending);
          }
        } catch (fallbackError) {
          try {
            const res = await axios.get('/accounts', {
              headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
              },
            });
            this.paymentSettings = res.data.payment_settings || {};
            this.withdrawMode = defaultWithdrawMode(this.paymentSettings);
          } catch (accountsError) {
            console.log(accountsError);
          }
        }
      }
    },
    async sendWithdrawData() {
      let withdrawAmount = 0;
      let deductedLocally = false;

      try {
        const authUser = await this.fetchUser();
        this.errors = {};
        if (!this.selected_account.account_id) {
          this.errors.account = this.$store.state.language === 'en'
            ? 'Please pick account type'
            : 'အကောင့်အမျိုးအစား ရွေးချယ်ပေးပါ။';
          return false;
        }
        if (!this.validateAccountNumber(true)) {
          return false;
        }
        if (!this.withdrawData.amount) {
          this.errors.amount = this.$store.state.language === 'en'
            ? 'Please enter amount'
            : 'ငွေပမာဏထည့်ပေးပါ။';
          return false;
        }
        if (this.withdrawData.amount < 2000) {
          this.errors.amount = this.$store.state.language === 'en'
            ? 'Please enter at least 2000 MMK'
            : 'ငွေပမာဏအနည်းဆုံး 2000 ထည့်ပေးပါ။';
          return false;
        }
        if (parseInt(this.withdrawData.amount, 10) > MAX_WITHDRAW_AMOUNT) {
          this.errors.amount = this.$t('withdraw.enter_max_withdraw');
          return false;
        }
        if (!this.withdrawData.account_name) {
          this.errors.name = this.$store.state.language === 'en'
            ? 'Please enter payment account name'
            : 'ငွေလက်ခံမည့် အကောင့်နာမည် ထည့်သွင်းပေးပါ။';
          return false;
        }
        if (this.withdrawData.amount > parseInt(authUser.amount, 10)) {
          Dialog.alert({
            message: this.$t('withdraw.insufficient_balance'),
            confirmButtonText: this.$t('withdraw.go_back'),
          });
          return false;
        }
        if (this.isConfirm || this.isReviewing) {
          return false;
        }

        this.isReviewing = true;
        let confirmed = false;
        try {
          confirmed = await this.confirmWithdrawDetails();
        } finally {
          this.isReviewing = false;
        }
        if (!confirmed) {
          return false;
        }
        if (this.isConfirm) {
          return false;
        }

        withdrawAmount = parseInt(this.withdrawData.amount, 10);
        const isAuto = this.isAutoWithdraw;

        if (!isAuto) {
          deductedLocally = true;
          this.$store.commit(
            'setAmount',
            this.$store.state.amount - withdrawAmount,
          );
        }

        this.isConfirm = true;

        const payload = {
          amount: withdrawAmount,
          account_number: this.withdrawData.account_number,
          account_name: this.withdrawData.account_name,
          remark: this.withdrawData.remark,
          date: this.currentTime,
        };

        if (isAuto) {
          payload.bank_code = this.selected_account.account_id;
          payload.use_psp = true;
        } else {
          payload.type = this.selected_account.account_id;
        }

        const res = await axios.post('/withdraws', payload, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });

        if (isAuto) {
          const result = applyAutoWithdrawResponse(res.data);
          this.applyPspWithdraw(result);

          if (result?.summary?.otp_required) {
            Toast.success(this.$t('withdraw.otp_required'));
          } else if (result?.provider !== 'myanpay' || result?.summary?.status !== 'confirm') {
            Toast.success(this.$t('withdraw.processing_hint'));
          }
        } else {
          Toast.success('Success');
        }

        this.withdrawData = {};
        this.selected_account.account_id = null;
        this.accountNumberTouched = false;
        this.errors = {};
        this.isConfirm = false;
        this.fetchUser();
      } catch (error) {
        this.isConfirm = false;
        if (deductedLocally) {
          this.$store.commit(
            'setAmount',
            this.$store.state.amount + withdrawAmount,
          );
        } else {
          this.fetchUser();
        }
        let errorMessage = 'ငွေထုတ်၍ မရသေးပါ။ Customer service သို့ဆက်သွယ်ပေးပါ။';
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message;
        }

        Dialog.alert({
          message: errorMessage,
          confirmButtonText: this.$t('withdraw.go_back'),
        });
      }
      return true;
    },
    createDateWithTimeZone() {
      const moment = require('moment-timezone');
      const dateInTimeZone = moment.tz(new Date(), 'Asia/Rangoon');
      const year = dateInTimeZone.year();
      const month = dateInTimeZone.month();
      const day = dateInTimeZone.date();
      const hour = dateInTimeZone.hour();
      const minute = dateInTimeZone.minute();
      const second = dateInTimeZone.second();
      const millisecond = dateInTimeZone.millisecond();
      return new Date(year, month, day, hour, minute, second, millisecond);
    },
  },
  computed: {
    isAutoWithdraw() {
      return this.withdrawMode === 'auto';
    },
    isManualWithdraw() {
      return this.withdrawMode === 'manual';
    },
    showModeSelector() {
      return this.paymentSettings.auto_withdraw && this.paymentSettings.manual_withdraw;
    },
    activeAccounts() {
      return this.isAutoWithdraw ? this.pspBanks : MANUAL_WITHDRAW_ACCOUNTS;
    },
    selectedAccountLabel() {
      const id = this.selected_account.account_id;
      const match = (this.activeAccounts || []).find((account) => account.id === id);
      return match?.name || id || '';
    },
    showMyanpayOtpForm() {
      return Boolean(
        this.pspWithdraw?.otp_required
          || (this.autoWithdrawProvider === 'myanpay' && this.pspWithdraw?.tx_id),
      );
    },
    currentTime() {
      return moment(this.createDateWithTimeZone()).format('lll');
    },
  },
  async mounted() {
    const authUser = await this.fetchUser();
    if (!authUser) {
      this.$router.push('/auth/login');
    }
    if (authUser && !authUser.is_verified) {
      this.$router.push('/auth/verify');
    }
    await this.loadPaymentConfig();
  },
  beforeDestroy() {
    this.stopStatusPolling();
  },
};
</script>
<style scoped>
.custom-btn {
  background: #000000 !important; 
  border: 1px solid rgb(240 97 38 / 1) !important;
  box-shadow: none !important;
  color: white !important;
  width: 100% !important;
  border-radius: .5rem;
  height: 40px !important;
}

.psp-withdraw-panel {
  background: rgba(0, 0, 0, 0.35);
  border-radius: 12px;
  padding: 1rem 1.25rem;
}

.number-container {
  border-radius: 5px;
  background: rgba(255, 255, 255, 0.08);
  justify-content: center;
}

.phone-input--invalid {
  box-shadow: 0 0 0 1px #ee0a24 !important;
}

@media (max-width: 768px) {
  .main-wrapper {
      padding: 7px !important;
  }
}
</style>
<style>
.withdraw-confirm-dialog .van-dialog__message {
  text-align: left;
  white-space: normal;
}

.withdraw-confirm__hint {
  margin: 0 0 14px;
  text-align: center;
  color: #323233;
  font-size: 14px;
  line-height: 1.5;
}

.withdraw-confirm__row {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
  font-size: 14px;
  line-height: 1.4;
}

.withdraw-confirm__label {
  color: #646566;
  flex: 0 0 auto;
}

.withdraw-confirm__value {
  color: #323233;
  font-weight: 600;
  text-align: right;
  word-break: break-word;
}

.withdraw-confirm__phone {
  margin-top: 4px;
  padding: 10px 12px;
  border-radius: 8px;
  background: #fff5f5;
  border: 1px solid #ee0a24;
  color: #ee0a24;
  font-size: 24px;
  font-weight: 800;
  letter-spacing: 1px;
  text-align: center;
  line-height: 1.3;
  word-break: break-all;
}

.withdraw-confirm__alert {
  margin: 10px 0 0;
  padding: 8px 10px;
  border-radius: 8px;
  background: #fff7e8;
  border: 1px solid #ed6a0c;
  color: #ed6a0c;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.6;
  text-align: center;
}
</style>
